<div class="dropdown-container">
  <mat-form-field>
    <svg-icon [class.open]="isSelectOpened" key="down" class="desktop-arrow-icon"></svg-icon>
    <mat-select
      #matSelect
      disableOptionCentering
      (selectionChange)="onSelectionChange($event.value)"
      (click)="onSelectOpen()"
      (blur)="onSelectBlur($event)"
      panelClass="dropdown-list"
      [value]="selectedIndex"
    >
      <mat-select-trigger>
        <ng-container *ngTemplateOutlet="optionContent; context: { option: options[selectedIndex] }"></ng-container>
      </mat-select-trigger>
      <mat-option
        *ngFor="let option of options; let index = index"
        [value]="index"
        [attr.data-testid]="
          index === 0
            ? 'SeriesDetailsPage.seasonDropDownFirstOption'
            : index === 1
            ? 'SeriesDetailsPage.seasonDropDownSecondOption'
            : 'SeriesDetailsPage.seasonDropDownOption'
        "
      >
        <span class="label option">{{ translateOptions ? (option.label | translate) : option.label }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <ng-template #optionContent let-option="option">
    <ng-container *ngIf="option">
      <span class="label">{{ translateOptions ? (option.label | translate) : option.label }}</span>
      <span *ngIf="option.secondaryLabel" class="secondary-label">{{ option.secondaryLabel }}</span>
    </ng-container>
  </ng-template>
</div>
